import { render, staticRenderFns } from "./add.vue?vue&type=template&id=7b71ceb6&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=7b71ceb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../viewport/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b71ceb6",
  null
  
)

export default component.exports